export const getPaymentMethodString = paymentMethod => {
  const key = ['VISA', 'DISC', 'MC', 'AMEX'].find(
    type => paymentMethod === type
  );

  return key || 'OtherPaymentMethod';
};

export const getPaymentRoute = (route, currentPathname) => {
  if (!route || !currentPathname) return;
  const paymentRoute = currentPathname.substring(
    0,
    currentPathname.indexOf('payment') + 7
  );
  return paymentRoute + route;
};

export const getIsAmexAccepted = currentAppSlug =>
  ['tdlrlr', 'accountSettings', 'dpslr', 'dmvrr', 'tpwdas'].includes(
    currentAppSlug
  );
